import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SurveyCompletedPage.css';

const SurveyCompletedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="completed-container">
      <div className="completed-card">
        <h1>Survey Already Submitted ✅</h1>
        <p>You have already completed this survey. Thank you!</p>
        <button className="back-btn" onClick={() => navigate('/')}>
          Go Back to Home
        </button>
      </div>
    </div>
  );
};

export default SurveyCompletedPage;
